export enum Environment {
  PROD = 'prod',
  STG = 'stg',
  INT = 'int'
}
